// store/thunks/auth/select2FAMethodThunk.ts

import { createAdminAsyncThunk } from "@/store/thunks/createAdminAsyncThunk";
import { sessionExpired } from "@/store/slices/auth/authSlice";
import type { TwoFactorMethod } from "@/types/authState.types";
import type { VerificationDTO } from "@/types/dtos.types";
import { isJWTExpired } from "@/utils/jwtDecoder";

export const select2FAMethodThunk = createAdminAsyncThunk<
  VerificationDTO,
  { method: TwoFactorMethod },
  { rejectValue: { message: string } }
>(
  'auth/select2FAMethod',
  async({ method }, { getState, dispatch, extra: { authService }, rejectWithValue }) => {
    const state = getState();
    const { regToken: twoFactorToken } = state.auth;

    if (twoFactorToken === undefined) {
      return rejectWithValue({ message: 'Missing session token' });
    }

    if (isJWTExpired(twoFactorToken)) {
      dispatch(sessionExpired());
      return rejectWithValue({ message: 'Session Expired. Please Login Again.' });
    }

    try {
      return await authService.selectTwoFactorMethod({ twoFactorToken, method });
    } catch (caught) {
      const message = caught instanceof Error ? caught.message : 'Failed to select 2FA method';
      return rejectWithValue({ message });
    }
  }
);

